"use client";
import React, { createContext, useContext } from "react";

type TProps = {
  children: React.ReactNode;
  lang: TLang;
};
type TLang = "ar" | "en";
type TLangContextValue = TLang;

const LangContext = createContext<null | TLangContextValue>(null);

const LangProvider: React.FC<TProps> = ({ children, lang: initLang }) => {
  return (
    <LangContext.Provider value={initLang}>{children}</LangContext.Provider>
  );
};

export default LangProvider;

export const useLang = () => {
  const LangContextValue = useContext(LangContext);
  if (!LangContextValue) {
    throw Error("useLang should be call inside LangProvider");
  } else {
    return LangContextValue;
  }
};
